<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-profil"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.user | user }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.service'"></strong>
                <span>{{ data.user | user:'orga' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.role'"></strong>
                <span>{{ data.libelleRole }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.dateDebut'"></strong>
                <span>{{ data.dateDebut | date:'shortDate' }}</span>
            </li>
            <li *ngIf="data.dateFin">
                <strong [translate]="'admin.entreprise.populations.usage.dateFin'"></strong>
                <span>{{ data.dateFin | date:'shortDate' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.actif'"></strong>
                <span>{{ 'filter.valeurOuiNon.' + !!data.actif | translate }}</span>
            </li>
        </ul>
    </div>
</div>